import classNames from 'classnames';
import ErrorBlock from '@features/ErrorBlock/ErrorBlock';
import type { TWrapperErrorBlock } from '../models/wrapperErrorBlock.models';
import styles from '../WrapperAbcloudzFlowChat.module.css';

const WrapperErrorBlock = ({ error, onRetry }: TWrapperErrorBlock) => {
  return (
    <div className={classNames(styles.flowPage, styles.error)}>
      <ErrorBlock
        title={error?.title}
        message={error?.message}
        buttonText='Please try refreshing the page'
        onClick={onRetry}
      />
    </div>
  );
};

export default WrapperErrorBlock;
